import { useState } from "react";

export default function OfflineFallback() {
    const [reloading, setReloading] = useState(false);

    const handleReload = () => {
        setReloading(true);
        window.location.reload();
    };

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-gray-500 text-white shadow-lg">
            <div className="flex items-center justify-between gap-3 px-4 py-1.5 max-w-3xl mx-auto">
                {/* Left side: animated dot + message */}
                <div className="flex items-center gap-2.5 min-w-0">
                    <span className="w-2.5 h-2.5 rounded-full bg-red-500 animate-pulse shrink-0" />
                    <p className="text-sm truncate">
                        <span className="font-medium">You're offline.</span>{" "}
                        <span className="text-gray-300">
                            No internet..
                        </span>
                    </p>
                </div>

                {/* Right side: reload button */}
                <button
                    onClick={handleReload}
                    disabled={reloading}
                    className="shrink-0 flex items-center gap-1.5 px-2 py-1 rounded-md text-white text-sm font-medium transition hover:bg-white/10 active:scale-95 disabled:opacity-60"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className={`w-4 h-4 ${reloading ? "animate-spin" : ""}`}
                    >
                        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                        <path d="M21 3v5h-5" />
                        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                        <path d="M3 21v-5h5" />
                    </svg>
                    {reloading ? "..." : "Reload"}
                </button>
            </div>
        </div>
    );
}